import { render, staticRenderFns } from "./datastatis.vue?vue&type=template&id=074ad8b6&scoped=true&"
import script from "./datastatis.vue?vue&type=script&lang=js&"
export * from "./datastatis.vue?vue&type=script&lang=js&"
import style0 from "./datastatis.vue?vue&type=style&index=0&id=074ad8b6&scoped=true&lang=css&"
import style1 from "./datastatis.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074ad8b6",
  null
  
)

export default component.exports